import React from 'react';
import { motion } from 'framer-motion';
import { Droplets } from 'lucide-react';
export function Problem() {
  return <section className="py-20 bg-cream-100" data-id="element-105">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-107">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-rust-50 text-rust mb-8" data-id="element-108">
            <Droplets size={32} data-id="element-109" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-8" data-id="element-110">
            La "Cubeta de Histamina" Desbordada
          </h2>

          <div className="prose prose-lg mx-auto text-charcoal-500 space-y-6" data-id="element-111">
            <p className="text-xl leading-relaxed font-medium text-charcoal" data-id="element-112">
              El error más común es creer que tu perro tiene una "enfermedad
              externa". La realidad es que su cubeta de histamina se ha
              desbordado.
            </p>
            <p data-id="element-113">
              Su sistema inmunitario está confundido, atacando todo a su paso
              porque su intestino y su entorno están saturados de toxinas
              invisibles.
            </p>
            <p className="p-6 bg-white rounded-xl shadow-sm border border-cream-300 text-rust-700 italic" data-id="element-114">
              Cada día que permites que el rascado continúe, la piel se
              debilita, abriendo la puerta a infecciones profundas, levaduras y
              un daño crónico que le resta años de vida y felicidad a tu mejor
              amigo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}